export default __webpack_public_path__ + "_/images/app/android/android-en-1-cdc391b312adc277e9a9fb0418886e4055a8ca54a3741ea42d123411b090203c.png";